﻿import {UIBase} from "../Tools/Base/UIBase";
import {NUtils} from "../../Utils/NUtils";
import {Core} from "../../Base/Core";
import {GameCategory, GameScreen, MoneyType, UIState} from "../../enums";
import {Time} from "../../Utils/Unity/Time";
import {UISprite} from "../Tools/Base/UISprite";
import {UIButton} from "../Tools/Base/UIButton";
import {UIText} from "../Tools/Base/UIText";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UIAttention} from "../UIAttention";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {Scrollbox} from "pixi-scrollbox";

class MissionTimer extends UISprite {
    Awake() {
        this.lastTimerUpdate = 0;

        this.timeField = this.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-clock",
                iconAlign: "absolute-left",
                iconSize: 1.4,
                backgroundColor: 0x000000,
                backgroundAlpha: 0.5,
            })
        );
        this.timeField._label.anchor.set(0, 0.5);
    }

    Update() {
        this.lastTimerUpdate += Time.deltaTime;
        if (this.lastTimerUpdate > 1) {
            this.updateTimer();
        }
    }

    updateTimer() {
        this.lastTimerUpdate = 0;
        if (!Core.Player.Missions.HasActiveMission()) return;
        let activeMission = Core.Player.Missions.missionInProgress;
        let timer = Core.Player.Timers.GetTimerById(activeMission.timerId);
        if (!timer) return;

        let secondsLeft = timer.SecondsLeft;
        if (this.Active && timer.SecondsLeft <= 0) {
            this.SetActive(false);
            this.emit("Finished");
        } else {
            this.SetActive(true);
            this.timeField.label = NUtils.FormatSecondsToTime(secondsLeft);
        }
    }

    fitLayout(rect) {
        let newRect = rect.clone();
        newRect.width = rect.width * 0.8;
        newRect.height = rect.height * 0.3;
        newRect.x = (rect.width - newRect.width) * 0.5;
        newRect.y = -newRect.height * 0.5;
        this.timeField.fitLayout(newRect);
    }
}

class MissionsButton extends UINineSliceButton {
    constructor() {
        super("btn-blue", Core.Localizator.Get("missions"));
    }

    Awake() {
        this.missionTimer = this.addChild(new MissionTimer());
        this.missionAttention = this.addChild(
            new UIAttention(() => Core.Player.Missions.HasActiveMission() && !Core.Player.Missions.IsInProgress())
        );

        this.on("pointertap", () => {
            let hasActiveMission = Core.Player.Missions.HasActiveMission();
            if (!hasActiveMission) {
                Core.UI.missionEmpty.Show();
            } else {
                Core.UI.missionActive.Show();
            }
            this.missionAttention.SetActive(false);
            Core.Player.PlanetsSave.TutorSave.missions = true;
            Core.UI.tutorial.HideObjectHand(this);
        });

        this.missionTimer.on("Finished", () => this.emit("MissionFinished"));
    }

    //after clicked on collect btn in active mission
    inactiveMissionAttention(){
        this.missionAttention.SetActive(false);
    }

    Update() {
        this.missionTimer.Update();
        this.missionAttention.Update();
        this.missionTimer.SetActive(Core.Player.Missions.IsInProgress());
        if (Core.Player.PlanetsSave.TutorSave.step >= 9 && Core.UI.map.Active && !Core.UI.missionEmpty.Active && !Core.UI.missionsList.Active) {
            Core.UI.tutorial.ShowObjectHand(this);
        }
    }

    fitLayout(rect) {
        super.fitLayout(rect);
        this.missionTimer.fitLayout(rect);
    }
}

class PlanetTapBonusBadge extends UISprite {
    Awake() {
        this.back = this.addChild(new UINineSlice("bg-simple"));
        this.back.tint = 0xfc7b04;
        this.back.alpha = 0.5;

        this.title = this.addChild(new UIText(Core.Localizator.Get("planet_tap_bonus")));
        this.tapBonusField = this.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-gold",
                iconAlign: "right",
                iconSize: 0.8,
                textProps: {
                    fitTextTemplate: "00x",
                },
            })
        );

        this.planetId = 0;
    }

    Init(planetData) {
        this.planetId = planetData.id;
        let isPurchased = Core.Player.PlanetsSave.HasPlanet(this.planetId);
        this.tapBonusField.label = `x${planetData.tapIncomeMultiplayer}`;
        this.back.alpha = isPurchased ? 1 : 0.3;
    }

    UpdateUI() {
        let isPurchased = Core.Player.PlanetsSave.HasPlanet(this.planetId);
        this.back.alpha = isPurchased ? 1 : 0.3;
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);
        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.fitLayout(rect);

        rect.pad(-rect.width * 0.05, -rect.height * 0.05);

        rect.pad(0, -rect.height * 0.3);
        rect.y = parentRect.height * 0.05;
        this.title.fitLayout(rect);

        rect.y = rect.height + parentRect.height * 0.05;
        rect.height = parentRect.height * 0.9 - rect.height;
        this.tapBonusField.fitLayout(rect);
    }
}

class PlanetBtn extends UIButton {
    Awake() {
        super.Awake();
        this.planetId = 0;
        this.btn = this.addChild(new UIButton(""));
        this.priceField = this.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-gold",
                iconAlign: "right",
                iconSize: 0.8,
                textProps: {
                    fitTextTemplate: "000.0xx",
                },
            })
        );
        this.youAreHere = this.addChild(
            new UILabeledIcon({
                label: Core.Localizator.Get("you_are_here"),
                backgroundColor: 0xfc7b04,
                backgroundAlpha: 0.9,
            })
        );
        this.titleField = this.addChild(new UIText(""));
        this.tapBonusField = this.addChild(new PlanetTapBonusBadge());
    }

    Init(planetData) {
        this.planetId = planetData.id;
        this.btn.on("pointertap", () => this.emit("PlanetClick", this.planetId));
        this.tapBonusField.Init(planetData);
        this.Update();
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.btn.fitRect(rect);

        let badgeRect = rect.clone().pad(-rect.width * 0.1, -rect.height * 0.4);
        this.priceField.fitLayout(badgeRect);

        badgeRect.y = -badgeRect.height;
        this.youAreHere.fitLayout(badgeRect);

        badgeRect.y = rect.height - badgeRect.height * 0.5;
        this.titleField.fitLayout(badgeRect);

        let tapBonusRect = new PIXI.Rectangle(rect.width * 0.6, rect.width * 0.1, rect.width * 0.5, rect.width * 0.2);
        this.tapBonusField.fitLayout(tapBonusRect);
    }

    Update() {
        let planetData = Core.GameData.Planets.GetPlanet(this.planetId);
        let isPurchased = Core.Player.PlanetsSave.HasPlanet(this.planetId);
        let youAreHere = Core.Player.PlanetsSave.currentPlanetId == this.planetId;
        this.titleField.text = isPurchased ? Core.Localizator.Get(planetData.planetName) : "???";
        this.priceField.label = NUtils.FormatMoney(planetData.GetPrice().priceValue);
        this.youAreHere.SetActive(youAreHere);
        this.priceField.SetActive(!isPurchased);
        this.btn.setImage(isPurchased ? `map/planet${this.planetId}` : `map/planet${this.planetId}dark`);
        this.tapBonusField.UpdateUI();
    }
}

export class UIMap extends UIBase {
    Awake() {
        super.Awake();

        this.onPlayerDataChanged = this.onPlayerDataChanged.bind(this);
        this.OnPlanetClick = this.OnPlanetClick.bind(this);

        this.space = this.addChild(
            new Scrollbox({
                overflow: "scroll",
                scrollbarSize: 0,
                dragScroll: false,
            })
        );
        this.back = this.space.content.addChild(new UISprite("map/cosmos"));
        this.back.anchor.set(0);

        this.planets = this.addChild(
            new Scrollbox({
                overflow: "scroll",
                scrollbarSize: 0,
                interaction: Core.app.renderer.plugins.interaction,
            })
        );

        this.missionsBtn = this.addChild(new MissionsButton());
        this.closeBtn = this.addChild(new UIButton("map-close"));

        this.planetItems = [];
        this.HideWithBackButton = true;

        Core.Player.on("Changed", this.onPlayerDataChanged);
    }

    Init() {
        super.Init();
        this._createPlanetButtons();
        this.closeBtn.on("pointertap", () => Core.UI.SetState(UIState.Game));
        this.missionsBtn.on("MissionFinished", () => this.updateUI());
    }

    _createPlanetButtons() {
        for (let p of Core.GameData.Planets.planets) {
            let btn = this.planets.content.addChild(new PlanetBtn());
            btn.Init(p);
            btn.on("PlanetClick", this.OnPlanetClick);
            this.planetItems.push(btn);
        }
    }

    _findPlanetItem(planetId) {
        for (let item of this.planetItems) {
            if (item.planetId === planetId) return item;
        }
    }

    scrollToPlanet(planetId) {
        let item = this._findPlanetItem(planetId);
        if (!item) return;
        let { scrollWidth, scrollHeight, boxWidth, boxHeight } = this.planets;
        let x = item.position.x - boxWidth * 0.5;
        let y = item.position.y - boxHeight * 0.5;
        this.planets.scrollLeft = Math.max(0, Math.min(x, scrollWidth - boxWidth));
        this.planets.scrollTop = Math.max(0, Math.min(y, scrollHeight - boxHeight));
    }

    fitLayout(viewport = Core.app.viewport) {
        const { width, height } = viewport;

        let ratio = width / height;

        let sideRatio = 1;
        let closeBtnRect = new PIXI.Rectangle(0, 0, 0, 0);
        closeBtnRect.width = Math.min(width * 0.17, (height * 0.1) / sideRatio);
        closeBtnRect.height = closeBtnRect.width * sideRatio;
        closeBtnRect.x = width * 0.8;
        closeBtnRect.y = height * 0.2 * ratio;
        this.closeBtn.fitRect(closeBtnRect);

        sideRatio = 0.5;
        let missionsRect = new PIXI.Rectangle(0, 0, 0, 0);
        missionsRect.width = Math.min(width * 0.4, (height * 0.1) / sideRatio);
        missionsRect.height = missionsRect.width * sideRatio;
        missionsRect.x = (width - missionsRect.width) * 0.1;
        missionsRect.y = (height - missionsRect.height) * 0.95;
        this.missionsBtn.fitLayout(missionsRect);

        let totalWidth = width + width * 0.8;
        let totalHeight = height + width * 0.6;

        sideRatio = 1;
        let planetRect = new PIXI.Rectangle(0, 0, 0, 0);
        planetRect.width = Math.min(width * 0.4, (height * 0.25) / sideRatio);
        planetRect.height = planetRect.width * sideRatio;

        let startPos = {
            0: { x: 0.6, y: 0.9 },
            1: { x: 0.37, y: 0.65 },
            2: { x: 0.8, y: 0.55 },
            3: { x: 0.27, y: 0.35 },
            4: { x: 0.64, y: 0.2 },
            5: { x: 0.1, y: 0.1 },
        };

        this.planetItems.forEach((planet, i) => {
            planetRect.x = (totalWidth - planetRect.width) * startPos[i].x;
            planetRect.y = (totalHeight - planetRect.height) * startPos[i].y;
            planet.fitLayout(planetRect);
        });

        let max = Math.max(totalWidth, totalHeight);
        this.back.scale.set(Math.max(max / this.back.texture.width, max / this.back.texture.height));

        this.space.resize({
            boxWidth: width,
            boxHeight: height,
            scrollWidth: totalWidth,
            scrollHeight: totalHeight,
        });

        this.planets.resize({
            boxWidth: width,
            boxHeight: height,
            scrollWidth: totalWidth,
            scrollHeight: totalHeight,
        });
    }

    OnPlanetClick(planetId) {
        let planetData = Core.GameData.Planets.GetPlanet(planetId);
        let isPurchased = Core.Player.PlanetsSave.HasPlanet(planetId);
        if (isPurchased) {
            console.log("PLANET CHANGE: ", planetId);
            Core.Player.PlanetsSave.SetCurrentPlanet(planetId);
            Core.UI.SetState(UIState.Game);
            Core.Audio.Play("UIToMap");
        } else {
            console.log("PLANET PURCHASE: ", planetId);
            if (Core.Player.SpendMoney(planetData.GetPrice(), GameCategory.planet, GameScreen.map, planetData.planetName)) {
                console.log("PLANET PURCHASED: ", planetId);
                Core.Player.PlanetsSave.AddPlanet(planetId);
                this.updateUI();
            } else {
                console.log("PLANET NOT PURCHASED: not enough money", planetId, planetData.GetPrice());
                switch (planetData.GetPrice().priceType) {
                    case MoneyType.Soft:
                        Core.UI.SetState(UIState.BankSoft);
                        break;
                    case MoneyType.Hard:
                        Core.UI.SetState(UIState.BankHard);
                        break;
                }
            }
        }
    }

    Show() {
        Core.Player.PlanetsSave.TutorSave.map = true;
        this.updateUI();
        this.fitLayout();
        this.scrollToPlanet(Core.Player.PlanetsSave.currentPlanetId);
        this.updateScroll();
        super.Show();
    }

    Hide() {
        if (this.Active) {
            Core.Ads.TriggerInterstitial();
        }
        Core.UI.tutorial.HideObjectHand();
        super.Hide();
    }

    onPlayerDataChanged() {
        if (!Core.Player.Initialized) return;
        this.updateUI();
    }

    Update() {
        this.missionsBtn.Update();
        this.updateScroll();
    }

    updateScroll() {
        this.space.scrollLeft = this.planets.scrollLeft * 0.5;
        this.space.scrollTop = this.planets.scrollTop * 0.5;
    }

    updateUI() {
        this.missionsBtn.Update();
        for (let p of this.planetItems) {
            p.Update();
        }
    }
}
